import { render } from "./LicenceProduct.vue?vue&type=template&id=16c67918"
import script from "./LicenceProduct.vue?vue&type=script&lang=js"
export * from "./LicenceProduct.vue?vue&type=script&lang=js"

import "./LicenceProduct.vue?vue&type=style&index=0&id=16c67918&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__